import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

const smartHomeUrl = environment.smartHomeUrl;

@Injectable({
  providedIn: 'root'
})
export class UsuariosService {

  private apiUrl: string;

  constructor(
    private _http: HttpClient,
  ) { 
    this.apiUrl = `${smartHomeUrl}api/`;
  }

  listarUsuarios(): Observable<any> {

    let url =  `${this.apiUrl}usuarios`;

    return this._http.get(url, { });

  }

  guardarUsuarios(data): Observable<any> {

    let myData = { 
      "name": data.name,
      "last_name": data.lastName,
      "number_document": data.numberDocument,
      "indicative": data.indicative,
      "phone": data.phone
    }

    let url = `${this.apiUrl}usuarios`;
   
    return this._http.post(url, myData);

  }

  eliminarUsuarios( idUsuario ) {
      let url = `${this.apiUrl}usuarios/usuario/${idUsuario}`;
    
      return this._http.delete(url, {});     
  }

  descargarFormatoExcel(companyId: number): Observable<Blob> {
    let url = `${this.apiUrl}masive/download-template/${companyId}`;
    return this._http.get(url, { responseType: 'blob' });
  }

  subirArchivoMasivo(file: File): Observable<any> {
    let url = `${this.apiUrl}masive/upload`;
    let formData = new FormData();
    formData.append('file', file);
    return this._http.post(url, formData);
  }

  listarUsuariosMasivos(companyId: number): Observable<any> {
    let url = `${this.apiUrl}masive/email-status/${companyId}`;
    return this._http.get(url);
  }

  reenviarCorreo(usId: number, urId: number): Observable<any> {
    let url = `${this.apiUrl}masive/resend-email`;
    let body = {
      us_id: usId,
      ur_id: urId
    };
    return this._http.post(url, body);
  }
}
